<script lang="ts" setup>
import { useI18n } from "vue-i18n";

import ImageResponsive from "@/components/ImageResponsive.vue";

const { t } = useI18n();
</script>

<template>
  <div class="empty-result-container">
    <ImageResponsive src="/assets/img/boy-with-looking-glass@1x.png" class="mb-5" presentational />
    <h3 class="mb-2 text-center">{{ t("article.noResults.heading") }}</h3>
    <p class="text-center">{{ t("article.noResults.subtext") }}</p>
  </div>
</template>

<style lang="less" scoped>
.empty-result-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}
</style>
